import { render } from "./WSection.vue?vue&type=template&id=78d2d0fa"
import script from "./WSection.vue?vue&type=script&lang=js"
export * from "./WSection.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__